import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { UploadFile, INVALID_EXTENSION, FILE_TOO_BIG } from './model';
import { PCModal } from 'portcall/pcmodal/view';

export const UploadFileView = SuperCritical(({ model: m } : { model : UploadFile }) =>
    <div className="uploadfile">
        <input type="file" className="uploadfile-file-input"
            key={m.FileInputId()}
            id={m.FileInputId()}
            accept={m.AllowedExtensions()}
            onChange={e => m.UploadFile((e.target as HTMLInputElement).files![0])} />
        <ValidationModal model={m} />
    </div>
);

let ValidationModal = SuperCritical(({ model: m } : { model : UploadFile }) =>
    <PCModal className="validationmodal" shown={() => !!(m.Validation()['ImageSize'] || m.Validation()['InvalidExtension'] || m.Validation()['FileTooBig'])}>
        <div className="modal-content">
            <div className="modal-body">
                <div className="clearfix">
                    <div>
                        {['ImageSize', INVALID_EXTENSION, FILE_TOO_BIG].map(errorKey => 
                            m.Validation()[errorKey] &&
                                <span key={errorKey}>{m.Validation()[errorKey]!.ErrorText}</span>
                        )}
                    </div>
                    <div className="actions-container">
                        <button className="pc-button pc-button-primary" onClick={m.ResetValidation}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </PCModal>
);


// WEBPACK FOOTER //
// ./apps/portcall/uploadfile/view.tsx